/*!
 * NOREVI — jeden skonsolidowany plik JS.
 * Obsługuje: stan scrolla nagłówka, menu mobilne, wyszukiwarkę w nagłówku,
 * scroll-reveal (IntersectionObserver + stagger --i), tilt 3D produktu hero,
 * tilt 3D kart, system cząsteczek (canvas), AJAX „dodaj do koszyka”,
 * przełączanie wariantów produktu, galerię miniatur.
 * Respektuje prefers-reduced-motion.
 */
(function () {
  'use strict';

  var REDUCED_MOTION = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
    (window.NOREVI && window.NOREVI.reducedMotion === true);
  var FINE_POINTER = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* -----------------------------------------------------------------
     Toast + koszyk (AJAX add to cart)
     ----------------------------------------------------------------- */
  var toastEl = document.getElementById('nrv-toast');
  var toastTimer;
  function nrvToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }
  function nrvSetCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.remove('bump');
      void el.offsetWidth;
      el.classList.add('bump');
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.js-ajax-cart');
    if (!form || !window.fetch) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();

    var routes = (window.NOREVI && window.NOREVI.routes) || {};
    var strings = (window.NOREVI && window.NOREVI.strings) || {};
    var btn = form.querySelector('[type="submit"]');
    var labelEl = btn ? btn.querySelector('[data-btn-label]') : null;
    var originalLabel = labelEl ? labelEl.textContent : (btn ? btn.textContent : '');
    if (btn) btn.disabled = true;

    fetch((routes.cart_add_url || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || strings.error || 'Nie udało się dodać produktu.');
        if (btn) {
          btn.classList.add('done');
          if (labelEl) labelEl.textContent = '✓ ' + (strings.added || 'Dodano');
          else btn.textContent = '✓ ' + (strings.added || 'Dodano');
        }
        nrvToast((strings.added || 'Dodano do koszyka') + ': ' + res.data.product_title);
        return fetch((routes.cart_url || '/cart') + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) nrvSetCartCount(cart.item_count); })
      .catch(function (err) { nrvToast(err.message); })
      .finally(function () {
        setTimeout(function () {
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('done');
            if (labelEl) labelEl.textContent = originalLabel;
            else btn.textContent = originalLabel;
          }
        }, 1600);
      });
  });

  /* -----------------------------------------------------------------
     Nagłówek: stan scrolla
     ----------------------------------------------------------------- */
  var header = document.querySelector('[data-nrv-header]');
  if (header) {
    var setScrolled = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
  }

  /* Menu mobilne */
  var menuBtn = document.getElementById('nrv-menu-btn');
  var mobileMenu = document.getElementById('nrv-mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () {
      var open = mobileMenu.hasAttribute('hidden');
      if (open) {
        mobileMenu.removeAttribute('hidden');
        mobileMenu.classList.add('is-open');
      } else {
        mobileMenu.classList.remove('is-open');
        mobileMenu.setAttribute('hidden', '');
      }
      menuBtn.setAttribute('aria-expanded', open);
    });
    mobileMenu.addEventListener('click', function (e) {
      if (e.target.closest('a')) {
        mobileMenu.classList.remove('is-open');
        mobileMenu.setAttribute('hidden', '');
        menuBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* Wyszukiwarka w nagłówku */
  var searchWrap = document.querySelector('[data-search]');
  var searchToggle = document.querySelector('[data-search-toggle]');
  if (searchWrap && searchToggle) {
    searchToggle.addEventListener('click', function () {
      var open = searchWrap.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open);
      if (open) {
        var input = searchWrap.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (searchWrap.classList.contains('is-open') && !searchWrap.contains(e.target)) {
        searchWrap.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchWrap.classList.contains('is-open')) {
        searchWrap.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.focus();
      }
    });
  }

  /* -----------------------------------------------------------------
     Galeria produktu: miniatury
     ----------------------------------------------------------------- */
  document.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = document.querySelector('.js-nrv-main-image');
      if (!main) return;
      main.src = b.dataset.thumb;
      main.removeAttribute('srcset');
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b); });
    });
  });

  /* -----------------------------------------------------------------
     Wariant produktu: cena, dostępność
     ----------------------------------------------------------------- */
  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var o = variantSelect.options[variantSelect.selectedIndex];
      var price = document.querySelector('[data-price]');
      var compare = document.querySelector('[data-compare]');
      var btn = document.querySelector('[data-add-btn]');
      var strings = (window.NOREVI && window.NOREVI.strings) || {};
      if (price) price.textContent = o.dataset.price;
      if (compare) { compare.textContent = o.dataset.compare || ''; compare.hidden = !o.dataset.compare; }
      if (btn) {
        var available = o.dataset.available === 'true';
        btn.disabled = !available;
        var labelEl = btn.querySelector('[data-btn-label]');
        var text = available ? (strings.addToCart || 'Dodaj do koszyka') : (strings.soldOut || 'Wyprzedane');
        if (labelEl) labelEl.textContent = text; else btn.textContent = text;
      }
    });
  }

  /* -----------------------------------------------------------------
     Scroll-reveal ([data-reveal] -> .is-in), ze staggerem --i
     ----------------------------------------------------------------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length) {
    if (REDUCED_MOTION || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      revealEls.forEach(function (el, i) {
        if (!el.style.getPropertyValue('--i')) el.style.setProperty('--i', i % 8);
      });
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
      revealEls.forEach(function (el) { revealObserver.observe(el); });
    }
  }

  if (REDUCED_MOTION) return; // Poniższe funkcje to wyłącznie ruch/3D/cząsteczki — pomijamy całkowicie.

  /* -----------------------------------------------------------------
     Tilt 3D: produkt hero (--px / --py na kontenerze data-nrv-tilt)
     ----------------------------------------------------------------- */
  if (FINE_POINTER) {
    document.querySelectorAll('[data-nrv-tilt]').forEach(function (stage) {
      var raf = null;
      function update(e) {
        var rect = stage.getBoundingClientRect();
        var px = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
        var py = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
        px = Math.max(-1, Math.min(1, px));
        py = Math.max(-1, Math.min(1, py));
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          stage.style.setProperty('--px', px.toFixed(3));
          stage.style.setProperty('--py', py.toFixed(3));
        });
      }
      stage.addEventListener('pointermove', update);
      stage.addEventListener('pointerleave', function () {
        if (raf) cancelAnimationFrame(raf);
        stage.style.setProperty('--px', 0);
        stage.style.setProperty('--py', 0);
      });
    });

    /* Tilt 3D: karty (--rx/--ry/--mx/--my), max ~4deg */
    var TILT_MAX = 4;
    document.querySelectorAll('.nrv-card, .nrv-benefit').forEach(function (card) {
      var raf = null;
      function onMove(e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        var y = (e.clientY - rect.top) / rect.height;
        var ry = (x - 0.5) * TILT_MAX * 2;
        var rx = (0.5 - y) * TILT_MAX * 2;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.setProperty('--rx', rx.toFixed(2) + 'deg');
          card.style.setProperty('--ry', ry.toFixed(2) + 'deg');
          card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        });
      }
      function onLeave() {
        if (raf) cancelAnimationFrame(raf);
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--mx', '50%');
        card.style.setProperty('--my', '50%');
      }
      card.addEventListener('pointermove', onMove);
      card.addEventListener('pointerleave', onLeave);
    });
  }

  /* -----------------------------------------------------------------
     System cząsteczek (canvas), warstwy głębi, subtelny ruch.
     Zatrzymywany, gdy hero poza ekranem lub karta w tle.
     ----------------------------------------------------------------- */
  document.querySelectorAll('[data-nrv-particles]').forEach(function (canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var wrap = canvas.closest('.nrv-backdrop') || canvas.parentElement;
    var particles = [];
    var running = false;
    var rafId = null;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var width = 0, height = 0;
    var LAYERS = 3;
    var COUNT = 46;

    function resize() {
      var rect = wrap.getBoundingClientRect();
      width = rect.width;
      height = rect.height;
      canvas.width = width * dpr;
      canvas.height = height * dpr;
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function seed() {
      particles = [];
      for (var i = 0; i < COUNT; i++) {
        var layer = i % LAYERS; // 0 = daleko/małe, 2 = blisko/duże
        particles.push({
          x: Math.random() * width,
          y: Math.random() * height,
          r: 0.7 + layer * 0.6 + Math.random() * 0.6,
          vx: (Math.random() - 0.5) * (0.05 + layer * 0.05),
          vy: (Math.random() - 0.5) * (0.05 + layer * 0.05),
          a: 0.12 + layer * 0.09 + Math.random() * 0.08,
          hueGold: Math.random() > 0.72
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, width, height);
      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < -10) p.x = width + 10; else if (p.x > width + 10) p.x = -10;
        if (p.y < -10) p.y = height + 10; else if (p.y > height + 10) p.y = -10;
        ctx.beginPath();
        ctx.fillStyle = p.hueGold ? 'rgba(216,185,139,' + p.a + ')' : 'rgba(62,123,255,' + p.a + ')';
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
      }
      if (running) rafId = requestAnimationFrame(draw);
    }

    function start() {
      if (running) return;
      running = true;
      if (!particles.length) { resize(); seed(); }
      rafId = requestAnimationFrame(draw);
    }
    function stop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    }

    window.addEventListener('resize', function () {
      resize();
      seed();
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !document.hidden) start(); else stop();
        });
      }, { threshold: 0.05 });
      io.observe(wrap);
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else if (wrap.getBoundingClientRect().top < window.innerHeight) start();
    });
  });
})();
